import React from "react";
import { Spinner } from "react-bootstrap";

export const StripePaymentButton = ({
  subscribeToPlanStripe,
  loading = false,
  disabled = false,
}) => {
  return (
    <>
      <div className="text-center">
        <button
          className="stripe-btn d-flex align-items-center justify-content-center gap-2"
          type="button"
          disabled={disabled || loading}
          onClick={disabled || loading ? undefined : subscribeToPlanStripe}
        >
          {loading ? (
            <span style={{ color: "#ffffff" }}>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Processing...
            </span>
          ) : (
            <span style={{ color: "#ffffff" }}>
              <i className="bi bi-stripe"></i> stripe
            </span>
          )}
        </button>
        <small className="text-center text-xs text-gray-700 hide-sm mt-0">
          Fast, secure payment with Stripe
        </small>
      </div>
    </>
  );
};
